/* © CNES */
import { QueryFunctionContext } from '@tanstack/react-query';
import { apiConfiguration } from '../APIConfiguration';
import { authenticationAPI } from '../authentication/AuthenticateAPI';

/**
 * Update profile information.
 * @param queryKey the query parameters.
 * @returns a Promise that will return a 200 status if the service has succeeded
 */
export const EditProfile = async ({
  queryKey,
}: QueryFunctionContext<any>): Promise<any> => {
  let res: Response | undefined;
  const [, formData] = queryKey;
  if (process.env.NODE_ENV === 'production') {
    res = await fetch(
      `${apiConfiguration.apiBaseUrl}/auth/realms/gdh/account`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...authenticationAPI.getAuthorizationHeaders(),
          Prefer: 'respond-async',
        },
        body: JSON.stringify(formData).replaceAll('\\', ''),
      }
    );
  } else {
    res = new Response(JSON.stringify({ test: 'OK' }));
  }
  return res?.json();
};
